(ns nosco.state.core
  (:require [hx.hooks :as hooks :refer [useEffect useValue]]
            ["react" :as react]
            [goog.object]))


;; Copied from hx.
(defn <-deref
  "Takes an atom. Returns the currently derefed value of the atom, and re-renders
  the component on change."
  ;; if no deps are passed in, we assume we only want to run
  ;; subscrib/unsubscribe on mount/unmount
  ([a]
   ;; create a react/useState hook to track and trigger renders
   (let [[v u] (react/useState @a)]
     ;; react/useEffect hook to create and track the subscription to the iref
     (react/useEffect
      (fn []
        (let [k (gensym "<-deref")]
          (add-watch a k
                     ;; update the react state on each change
                     (fn [_ _ _ v'] (u v')))
          ;; Check to ensure that a change has not occurred to the atom between
          ;; the component rendering and running this effect.
          ;; If it has updated, then update the state to the current value.
          (when (not= @a v)
            (u @a))
          ;; return a function to tell react hook how to unsubscribe
          #(remove-watch a k)))
      ;; pass in deps vector as an array
      ;; resubscribe if `a` changes
      #js [a])
     ;; return value of useState on each run
     v)))



(defn- default-reducer [global-reducer state [action & params]]
  (let [state (apply action state params)]
    (when global-reducer
      (apply global-reducer state params))))

(def ^{:private true} unmounted-key (str ::unmounted))

(defn- wrap-dispatch [dispatch]
  (fn [action & params]
    (when-not (goog.object/get dispatch unmounted-key)
      (dispatch (conj params action)))))

(def DispatchContext (react/createContext (fn dispatch [action]
                                            (js/console.log "Dispatch placeholder for context"))))

(defn useReducer
  "Like the react useReducer hook with the difference that the returned dispatch function takes the following parameters:
  - A reducer function
  - Any number of optional parameters
  The dispatch function calls the reducer function with the reducer state and the provided optional parameters.

  The \"global-reducer\" optional parameter provides a mean to implement cross cutting concerns.
  The \"global-reducer\" is called every time, and after, a reducer function is called."
  ([init]
   (useReducer init nil))
  ([init global-reducer]
   (let [[state dispatch] (hooks/useReducer (partial default-reducer global-reducer) init)]
     (hooks/useEffect
      (fn []
        (goog.object/set dispatch unmounted-key false)
        (fn []
          (goog.object/set dispatch unmounted-key true)))
      [])
     [state (wrap-dispatch dispatch)])))
